import React from "react";

import { emailPatternValidation } from "utils/form-validation";
import Input from "./input";

const InputEmail = ({ placeholder, ...props }) => {
  return (
    <Input
      name="email"
      placeholder={placeholder || "exemplo@mail.com"}
      inputMode="email"
      label="E-mail"
      pattern={emailPatternValidation}
      {...props}
    />
  );
};

export default InputEmail;
